module.exports = __webpack_public_path__ + "static/media/vercel.af7954e8.svg";